<template>
  <nuxt-link
    :data-type="`country-${item.id}`"
    :to="{
      name: 'search-country',
      params: {
        type: $t('router.search_type.type.country'),
        value: item.slug,
        travelTo: $t('router.search_type.travel_to_'),
      },
    }"
  >
    <span class="item-search-title">{{ item.name }}</span>
  </nuxt-link>
</template>

<script>
import LadSearchCommon from './common'

export default {
  name: 'LadSearchCountry',
  extends: LadSearchCommon,
}
</script>
